<template>
  <div>
    <a-card class="customer-filter" size="small">
      <fault-filter-form v-model="filterForm" @change="handleFilterChange" @reset="handleFilterReset" />
    </a-card>
    <a-card title="故障列表" class="filter-data">
      <span slot="extra">
        <a-button class="handle-menu" type="primary" icon="plus" @click="onAdd">添加</a-button>
      </span>
      <fault-data-list :loading="loading" :table-data="tableData" :pagination="pagination" @page-change="handlePageChange" @edit="onEdit" @delete="onDelete" @detail="onDetail" />
    </a-card>
    <fault-drawer :display="editVisible" :source-id="sourceId" @close="close" />
  </div>
</template>

<script>
import { faultList, faultDelete } from '@/api/event/fault';

import FaultDrawer from '@/pages/event/components/FaultDrawer';
import FaultDataList from '@/pages/event/components/FaultDataList';
import FaultFilterForm from '@/pages/event/components/FaultFilterForm';

export default {
  components: {
    FaultDrawer,
    FaultFilterForm,
    FaultDataList
  },
  data() {
    return {
      loading: false,
      sourceId: null,
      editVisible: false,
      filterForm: {
        title: null,
        time_field: 'reported_time',
        levels: [],
        projects: [],
        tags: [],
        domains: [],
        page_size: 10,
        page_number: 1
      },
      pagination: {
        size: 'large',
        total: 0,
        pageSize: this.$store.getters.pageSize, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      tableData: []
    };
  },
  created() {
    this.getFaultList();
  },
  methods: {
    // 点击添加
    onAdd() {
      this.sourceId = null;
      this.editVisible = true;
    },

    // 点击编辑
    onEdit(record) {
      this.sourceId = record.id;
      this.editVisible = true;
    },

    onDetail(record) {
      this.$router.push({
        name: 'page:event:fault:detail',
        query: {
          faultId: record.id
        }
      });
    },

    // 删除故障
    onDelete(id) {
      const self = this;
      this.$confirm({
        title: '确认',
        content: '确认要删除该故障吗',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          faultDelete({ id: id }).then(() => {
            self.$message.success('删除成功');
            self.getFaultList();
          });
        }
      });
    },

    // 获取故障列表
    getFaultList() {
      this.loading = true;
      faultList({ ...this.filterForm, page_size: this.pagination.pageSize, page_number: this.pagination.current })
        .then(res => {
          this.tableData = res.data.items;
          this.pagination.total = res.data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    // 筛选条件变更
    handleFilterChange(filterForm) {
      this.filterForm = { ...filterForm };
      this.pagination.current = 1;
      this.getFaultList();
    },

    // 筛选重置
    handleFilterReset(filterForm) {
      this.filterForm = { ...filterForm };
      this.getFaultList();
    },

    // 分页变更
    handlePageChange(pagination) {
      this.pagination = pagination;
      this.getFaultList();
    },

    // 关闭弹窗
    close(type) {
      this.editVisible = false;
      if (type === 'submit') {
        this.getFaultList();
      }
    }
  }
};
</script>

<style lang="less" scoped>
:deep(.customer-filter) {
  .ant-page-header {
    padding: 0;
  }
  margin-bottom: 16px;
  .ant-form-item {
    margin-bottom: 8px;
    display: flex;
    .ant-form-item-control-wrapper {
      flex: 1;
    }
  }
  .filter-right {
    float: right;
    text-align: right;
  }
}
.custom-link {
  color: rgba(0, 0, 0, 0.65);
}
.custom-link:hover {
  color: #1890ff;
}
</style>
